module.exports = __webpack_public_path__ + "static/media/icn-search-blue.f893449f.svg";